import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import Platform from "react-native-web/dist/exports/Platform";
import createMultiStyleIconSet from "./createMultiStyleIconSet";
export var FA5Style = {
  regular: 'regular',
  light: 'light',
  solid: 'solid',
  brand: 'brand'
};
export function createFA5iconSet(glyphMap) {
  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fonts = arguments.length > 2 ? arguments[2] : undefined;
  var pro = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var metadataKeys = Object.keys(metadata);
  var fontFamily = "FontAwesome5" + (pro ? 'Pro' : 'Free');

  function fallbackFamily(glyph) {
    for (var i = 0; i < metadataKeys.length; i += 1) {
      var family = metadataKeys[i];

      if (metadata[family].indexOf(glyph) !== -1) {
        return family === 'brands' ? 'brand' : family;
      }
    }

    return 'regular';
  }

  function glyphValidator(glyph, style) {
    var family = style === 'brand' ? 'brands' : style;
    if (metadataKeys.indexOf(family) === -1) return false;
    return metadata[family].indexOf(glyph) !== -1;
  }

  function createFontAwesomeStyle(styleName, fontWeight) {
    var family = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fontFamily;
    var fontFile = fonts[styleName];
    return {
      fontFamily: family + "-" + styleName,
      fontFile: fontFile,
      fontStyle: Platform.select({
        ios: {
          fontWeight: fontWeight
        },
        "default": {}
      }),
      glyphMap: glyphMap
    };
  }

  var brandIcons = createFontAwesomeStyle('Brand', '400');
  var lightIcons = createFontAwesomeStyle('Light', '100');
  var regularIcons = createFontAwesomeStyle('Regular', '400');
  var solidIcons = createFontAwesomeStyle('Solid', '700');
  var Icon = createMultiStyleIconSet({
    brand: brandIcons,
    light: lightIcons,
    regular: regularIcons,
    solid: solidIcons
  }, {
    defaultStyle: 'regular',
    fallbackFamily: fallbackFamily,
    glyphValidator: glyphValidator
  });
  return Icon;
}